/**
 * Límite de unidades por pedido (Matcha & CO)
 *
 * Las reglas llegan desde el metaobjeto `limite_pedido`, que theme.liquid
 * renderiza en window.__LIMITES_PEDIDO antes de cargar este fichero.
 *
 * Diagnóstico desde la consola:
 *   window.__limitePedido.reglas
 *   await window.__limitePedido.aplicar()
 */
(function () {
  // Un metaobjeto con 8 variantes emite 8 reglas del mismo producto
  var REGLAS = (window.__LIMITES_PEDIDO || []).reduce(function (acc, r) {
    if (!r.productId) return acc;
    var k = String(r.productId);
    if (!acc.vistos[k]) { acc.vistos[k] = true; acc.lista.push(r); }
    return acc;
  }, { vistos: {}, lista: [] }).lista;

  if (!REGLAS.length) {
    console.warn('[limite-pedido] sin reglas: revisa el metaobjeto limite_pedido');
    return;
  }

  // fetch nativo tomado de un iframe. Para cuando corremos, otras apps
  // (CornerCart entre ellas) ya han envuelto window.fetch y rompen estas
  // llamadas sin dar ningun error visible.
  var pedir = (function () {
    try {
      var f = document.createElement('iframe');
      f.style.display = 'none';
      document.documentElement.appendChild(f);
      return f.contentWindow.fetch.bind(window);
    } catch (e) {
      return window.fetch.bind(window);
    }
  })();

  var dejarPasar = false;

  async function ejecutar() {
    var cambiado = false;
    try {
      var carrito = await pedir('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });

      for (var n = 0; n < REGLAS.length; n++) {
        var regla = REGLAS[n];
        var lineas = carrito.items.filter(function (i) {
          if (String(i.product_id) !== String(regla.productId)) return false;
          return regla.soloRegalo ? i.final_price === 0 : true;
        });
        if (lineas.reduce(function (s, i) { return s + i.quantity; }, 0) <= regla.max) continue;

        // La linea de CornerCart va a 0; una anadida a mano, al precio completo
        var conservar = lineas.reduce(function (m, i) {
          return i.final_price < m.final_price ? i : m;
        }, lineas[0]);

        for (var k = 0; k < lineas.length; k++) {
          var obj = lineas[k].key === conservar.key ? regla.max : 0;
          if (lineas[k].quantity === obj) continue;
          // Por key: quitar una linea renumera las siguientes
          await pedir('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineas[k].key, quantity: obj })
          });
          cambiado = true;
        }
      }
    } catch (e) {
      console.warn('[limite-pedido] fallo:', e);
    }
    return cambiado;
  }

  // En cola, no con un candado: quien llega mientras otra pasada esta en vuelo
  // debe esperar a una nueva, no irse creyendo que ya esta verificado
  var cola = Promise.resolve();
  function aplicar() {
    cola = cola.then(ejecutar, ejecutar);
    return cola;
  }

  async function recalcular() {
    var cambiado = await aplicar();
    // En /cart el HTML lo pinta el servidor: sin recargar, la pantalla miente
    if (cambiado && /^\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function esCambio(u) {
    return typeof u === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(u);
  }

  // Mejor esfuerzo: otra app puede pisar estos parches, no dependemos de ellos
  try {
    var f0 = window.fetch;
    window.fetch = function (e) {
      var u = typeof e === 'string' ? e : (e && e.url) || '';
      return f0.apply(this, arguments).then(function (r) {
        if (esCambio(u)) setTimeout(recalcular, 150);
        return r;
      });
    };
    var x0 = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.addEventListener('load', function () {
        if (esCambio(u)) setTimeout(recalcular, 150);
      });
      return x0.apply(this, arguments);
    };
  } catch (e) {
    console.warn('[limite-pedido] no se pudo enganchar fetch/XHR:', e);
  }

  // /cart envia un formulario normal, que no pasa por fetch ni XHR
  document.addEventListener('submit', async function (ev) {
    var form = ev.target;
    if (!form) return;
    var accion = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/cart$/.test(accion)) return;
    var inputs = [].slice.call(form.querySelectorAll('input[name="updates[]"]'));
    if (!inputs.length) return;
    ev.preventDefault();
    try {
      var carrito = await pedir('/cart.js').then(function (r) { return r.json(); });
      var porKey = {};
      carrito.items.forEach(function (i) { porKey[i.key] = i; });
      var usado = {};
      // El tema pinta dos inputs por linea (escritorio y movil)
      inputs.forEach(function (inp) {
        var key = (inp.id || '').replace(/^updates_/, '');
        var item = porKey[key];
        if (!item) return;
        var regla = REGLAS.filter(function (r) {
          return String(r.productId) === String(item.product_id);
        })[0];
        if (!regla) return;
        if (regla.soloRegalo && item.final_price !== 0) return;
        if (!(key in usado)) {
          var ya = Object.keys(usado).reduce(function (s, k2) {
            if (!porKey[k2]) return s;
            return porKey[k2].product_id === item.product_id ? s + usado[k2] : s;
          }, 0);
          var pedido = parseInt(inp.value, 10) || 0;
          var tope = regla.max - ya;
          usado[key] = Math.max(0, Math.min(pedido, tope));
        }
        inp.value = String(usado[key]);
      });
    } catch (e) {
      console.warn('[limite-pedido] fallo al topar el formulario:', e);
    }
    form.submit();
  }, true);

  // Al pulsar pagar: retener, verificar de verdad, y soltar
  document.addEventListener('click', function (ev) {
    if (dejarPasar) return;
    if (!ev.target || !ev.target.closest) return;
    var el = ev.target.closest('button, a, input[type=submit]');
    if (!el) return;
    var nombre = (el.getAttribute('name') || '').toLowerCase();
    var href = (el.getAttribute('href') || '').toLowerCase();
    var texto = (el.textContent || '').trim().toLowerCase();
    var vaAlPago = nombre === 'checkout' ||
      href.indexOf('/checkout') !== -1 ||
      /finalizar compra|pagar pedido|ir a pagar|checkout/.test(texto);
    if (!vaAlPago) return;

    ev.preventDefault();
    ev.stopPropagation();
    aplicar().then(function () {
      dejarPasar = true;
      el.click();
      setTimeout(function () { dejarPasar = false; }, 3000);
    });
  }, true);

  window.__limitePedido = { aplicar: aplicar, reglas: REGLAS };

  recalcular();
})();
